import axios from "axios";
import { BASEURL, requestWrapper, setConfig } from "./request.util";

export const login = async (userDetails) => await requestWrapper(axios.post(`${BASEURL}/login`, userDetails));

export const passwordResetEmail = async (data) => await requestWrapper(axios.post(`${BASEURL}/password-reset-mail`, data));

export const passwordResetWithToken = async (data) => await requestWrapper(axios.post(`${BASEURL}/reset-password-token`, data));

export const changePassword = async (data) => await requestWrapper(axios.post(`${BASEURL}/change-password`, data, setConfig()));

export const deleteUser = async (data) => await requestWrapper(axios.post(`${BASEURL}/delete-user`, data, setConfig()));